import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import PageTemplateType from 'constants/PageTemplateType';
import { COMPONENT_SIDS } from 'constants/ShopYourStore';
import helperUtils from 'utils/Helpers';
import { COMPONENT_SIDS as SIDS } from 'components/GlobalModals/ChooseOptionsModal/constants';
import Empty from 'constants/empty';
import { CONSTRUCTOR_PODS } from 'constants/constructorConstants';

const { BASKET_YOUR_SAVED_ITEMS_CAROUSEL } = SIDS;
const { SHOP_MY_STORE_BUY_IT_AGAIN, SHOP_SAME_DAY_BUY_IT_AGAIN, SHOP_MY_STORE_FROM_YOUR_LOVES, SHOP_SAME_DAY_FROM_YOUR_LOVES } = COMPONENT_SIDS;
const { getProp } = helperUtils;
const { CHOOSE_OPTIONS_PLACEMENT_NAMES } = anaConsts;

const PLACEMENTS_MAP = {
    [PageTemplateType.MyLists]: 'mylistshomepage',
    [PageTemplateType.MyCustomList]: 'mylistshomepage',
    [PageTemplateType.PurchaseHistory]: 'buyitagain',
    [PageTemplateType.ShopMyStore]: 'sys',
    [PageTemplateType.ShopSameDay]: 'sdd',
    [PageTemplateType.RwdBasket]: 'basketcheckout',
    MY_LISTS_FLYOUT: 'mylistsflyout',
    LOVES_CAROUSEL: 'lovescarousel'
};

const COMPONENTS_MAP = {
    [SHOP_MY_STORE_FROM_YOUR_LOVES]: 'yourlists',
    [SHOP_SAME_DAY_BUY_IT_AGAIN]: 'buyitagain',
    [SHOP_SAME_DAY_FROM_YOUR_LOVES]: 'yourlists',
    [SHOP_MY_STORE_BUY_IT_AGAIN]: 'buyitagain',
    [BASKET_YOUR_SAVED_ITEMS_CAROUSEL]: 'yourloves'
};

const CAROUSEL_NAME_MAP = {
    [CONSTRUCTOR_PODS.YMAL]: CHOOSE_OPTIONS_PLACEMENT_NAMES.PDP_YOU_MAY_ALSO_LIKE,
    [CONSTRUCTOR_PODS.RFY]: CHOOSE_OPTIONS_PLACEMENT_NAMES.HOMEPAGE_CHOSEN_FOR_YOU,
    [CONSTRUCTOR_PODS.NEW_ARRIVALS]: CHOOSE_OPTIONS_PLACEMENT_NAMES.HOMEPAGE_NEW_ARRIVALS,
    [CONSTRUCTOR_PODS.SELLING_FAST]: CHOOSE_OPTIONS_PLACEMENT_NAMES.HOMEPAGE_SELLING_FAST
};

const PAGE_NAME = 'page.attributes.sephoraPageInfo.pageName';

class ChooseOptionsModalBindings {
    static getPageName() {
        return `${anaConsts.PAGE_TYPES.ADD_TO_BASKET_MODAL}:${anaConsts.PAGE_DETAIL.CHOOSE_OPTIONS}:${anaConsts.NOT_AVAILABLE}`;
    }

    static getPreviousPageName() {
        try {
            return getProp(digitalData, PAGE_NAME) || Empty.String;
        } catch (error) {
            Sephora.logger.error('Failed to get previous page name:', error);

            return Empty.String;
        }
    }

    static getProductStrings(skuId, carouselName) {
        if (carouselName) {
            return `;${skuId};;;;evar26=${skuId}|eVar69=${carouselName}`;
        }

        return `;${skuId};;;;evar26=${skuId}`;
    }

    static getUniquePlacementName({
        placementName, componentName, isInlineLoves, isLovesCarousel, podId
    }) {
        let uniquePlacementName;

        // Check if it's from a constructor carousel first
        if (podId && CAROUSEL_NAME_MAP[podId]) {
            return CAROUSEL_NAME_MAP[podId];
        }

        if (isLovesCarousel) {
            uniquePlacementName = PLACEMENTS_MAP.LOVES_CAROUSEL;
        } else if (isInlineLoves) {
            uniquePlacementName = PLACEMENTS_MAP.MY_LISTS_FLYOUT;
        } else {
            uniquePlacementName = PLACEMENTS_MAP[placementName];
        }

        if (componentName) {
            uniquePlacementName += `-${COMPONENTS_MAP[componentName]}`;
        }

        return uniquePlacementName;
    }

    static modalOpen = argumentsObj => {
        const { skuId, uniquePlacementName, podId } = argumentsObj;
        const carouselName = CAROUSEL_NAME_MAP[podId];
        const isFromConstructorCarousel = !!carouselName;

        if (isFromConstructorCarousel) {
            // Fire s.t() call with event269 for constructor carousels (YMAL, RFY, etc.)
            const data = {
                pageName: this.getPageName(),
                productStrings: this.getProductStrings(skuId, carouselName),
                eventStrings: [anaConsts.Event.EVENT_269],
                linkData: `${anaConsts.PAGE_TYPES.ADD_TO_BASKET_MODAL} open:${carouselName}`,
                internalCampaign: `${carouselName}:add-to-basket`,
                previousPageName: this.getPreviousPageName()
            };

            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
                data
            });
        } else {
            // Default behavior for other placements
            const data = {
                pageName: this.getPageName(),
                productStrings: this.getProductStrings(skuId),
                linkData: `${anaConsts.PAGE_TYPES.ADD_TO_BASKET_MODAL} open:${uniquePlacementName}`,
                previousPageName: this.getPreviousPageName()
            };

            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
                data
            });
        }
    };
}

export default ChooseOptionsModalBindings;
